<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="title-heading d-flex justify-content-between">
          <h1>{{ $static('callback.title', 'Заявки на зворотний дзвінок') }}</h1>
        </div>
        <div class="large-button-panel recall-sort-panel">
          <div class="search-panel w-40">
            <!--search panel-->
            <div class="search-group">
              <input type="text" class="input-search form-control custom-input"
                :placeholder="$static('callback.ph1', 'Знайти по id/телефону')" v-model="filter.search"
                @keydown.enter="getItems">
              <button class="search-btn" @click="getItems">
                <span class="icon icon-search"></span>
              </button>
            </div>
            <!-- end search panel-->
          </div>
          <div class="group-holder w-25">
            <div class="text-icon-group  dropdown-toggle" id="pay_status" data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="true">
              <span class="name">{{ $static('callback.status', 'Статус заявки') }}</span>
              <span class="icon icon-down"></span>
            </div>
            <ul class="dropdown-menu custom-dropdown" aria-labelledby="pay_status">
              <li>
                <!-- checkbox-->
                <div class="default-checkbox">
                  <input id="all_pay_status" type="checkbox" :checked="filter.status.length === 0"
                    @change="filter.status = []">
                  <label for="all_pay_status">{{ $static('callback.all', 'Усе') }}</label>
                </div>
                <!--end  checkbox-->
              </li>
              <li v-for="(status, index) in callStatusList" :key="index">
                <!-- checkbox-->
                <div class="default-checkbox">
                  <input :id="'new_status' + index" type="checkbox" v-model="filter.status" :value="status.value">
                  <label :for="'new_status' + index">{{ status.label }}</label>
                </div>
                <!--end  checkbox-->
              </li>
              <!--              <li>-->
              <!--                &lt;!&ndash; checkbox&ndash;&gt;-->
              <!--                <div class="default-checkbox">-->
              <!--                  <input id="success_status" type="checkbox" v-model="filter.status" value="Обработан">-->
              <!--                  <label for="success_status">Обработан</label>-->
              <!--                </div>-->
              <!--                &lt;!&ndash;end  checkbox&ndash;&gt;-->
              <!--              </li>-->
              <!--              <li>-->
              <!--                &lt;!&ndash; checkbox&ndash;&gt;-->
              <!--                <div class="default-checkbox">-->
              <!--                  <input id="pause_status" type="checkbox" v-model="filter.status" value="На паузе">-->
              <!--                  <label for="pause_status">На паузе</label>-->
              <!--                </div>-->
              <!--                &lt;!&ndash;end  checkbox&ndash;&gt;-->
              <!--              </li>-->
              <li>
                <div class="button-holder">
                  <button class="default-btn btn-accent" @click="getItems">
                    <span class="text">{{ $static('callback.accept', 'Застосувати') }}</span>
                  </button>
                </div>
              </li>
            </ul>
          </div>

          <div class="group-holder w-30">
            <v-date-picker @click.stop.prevent="" v-model.lazy="orderDate" is-range :locale="datePickerLocale">
              <template v-slot="{ inputValue, inputEvents }">
                <div class="d-flex justify-content-between items-center" v-if="orderDate.start && orderDate.end">
                  <input :value="inputValue.start" v-on="inputEvents.start"
                    class="form-control custom-input datapicker-input " style="width:49%" />
                  <input :value="inputValue.end" v-on="inputEvents.end"
                    class="form-control custom-input datapicker-input" style="width:49%" />
                </div>
                <div class="text-icon-group" v-on="inputEvents.start" v-else>
                  <span class="name">{{ $static('callback.f4', 'Час замовлення') }}</span>
                  <span class="icon icon-calendar"></span>
                </div>
              </template>
            </v-date-picker>
          </div>
        </div>
        <div class="table-wrapper">
          <div class="table-responsive">
            <table class="table custom-table">
              <thead>
                <tr>
                  <th>№</th>
                  <th>{{ $static('callback.t1', 'User ID') }}</th>
                  <th>{{ $static('callback.t2', 'Username') }}</th>
                  <th>{{ $static('callback.t3', 'Телефон') }}</th>
                  <th>{{ $static('callback.t4', 'Час заявки') }}</th>
                  <th>{{ $static('callback.t5', 'Статус заявки') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <th scope="row">{{ item.id }}</th>
                  <td class="w-standart">
                    <div class="user-id-prev">
                      <!--                    <span class="avatar bg" style="background-image: url(/images/avatar.png);"></span>-->
                      <span class="name">{{ item.info.id }}</span>
                    </div>
                  </td>
                  <td scope="row" class="w-standart">
                    {{ item.info.username }}
                  </td>
                  <td class="w-standart">
                    <a :href="`tel:${item.phone}`">{{ item.phone }}</a>
                  </td>
                  <td class="w-standart">{{ item.created_at.toLocaleString(currentLang) }}</td>
                  <td class="w-standart">
                    <div class="selector-holder">
                      <v-select id="editor_category" :options="callStatusList" :searchable="false" v-model="item.status"
                        :reduce="c => c.value" class="status-select" append-to-body :calculate-position="withPopper"
                        @option:selected="(e) => onChangeStatus(e, item)">
                        <template #selected-option="{ label, c }">
                          <p style="margin: 0" :class="c">{{ label }}</p>
                        </template>
                        <template #option="{ label, c }" class="together_list-item">
                          <p style="margin: 0" :class="c">{{ label }}</p>
                        </template>
                        <template #open-indicator="{ attributes }">
                          <span v-bind="attributes">
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M15.1528 8.22224C15.4213 8.49072 15.4213 8.92602 15.1528 9.19451L11.4861 12.8612C11.2177 13.1297 10.7824 13.1297 10.5139 12.8612L6.84721 9.19451C6.57872 8.92602 6.57872 8.49072 6.84721 8.22224C7.11569 7.95375 7.55099 7.95375 7.81948 8.22224L11 11.4028L14.1805 8.22224C14.449 7.95375 14.8843 7.95375 15.1528 8.22224Z"
                                fill="#212121" />
                            </svg>
                          </span>
                        </template>
                      </v-select>
                    </div>

                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="pagination-panel table-pagination" v-if="pages.length > 1">
          <nav>
            <router-link :to="{ name: 'CallBack', params: { page: Math.max(pageIndex - 1, 1) } }"
              class="previous extreme" :class="{ 'disabled': pageIndex < 2 }">
              <span class="icons icon-left"></span>
            </router-link>
            <ul class="pagination pagination-list">
              <li v-for="(page, index) in pages" :key="index" :class="{ 'active': pageIndex === page }">
                <router-link :to="{ name: 'CallBack', params: { page: page } }">{{ page }}</router-link>
              </li>
            </ul>
            <router-link :to="{ name: 'CallBack', params: { page: Math.min(pageIndex + 1, pageAmount) } }"
              class="end extreme" :class="{ 'disabled': pageIndex > pageAmount - 1 }">
              <span class="icons icon-right"></span>
            </router-link>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { createPopper } from '@popperjs/core'

const pageSlotsAmount = 5;

export default {
  name: 'Callback',
  props: ['page'],
  data() {
    return {
      placement: 'bottom',
      filter: {
        page: 1,
        perPage: 10,
        search: undefined,
        status: []
      },
      orderDate: {
        // start: new Date(new Date().getTime() - 24 * 60 * 60 * 1000),
        // end  : new Date()
      },
      sortBy: 'time',
      items: [],
      total: 0,
      callStatusList: [
        { label: 'Новый', value: 'Новый', c: 'new' },
        { label: 'Обработан', value: 'Обработан', c: 'success' },
        { label: 'На паузе', value: 'На паузе', c: 'pause' }
      ]
    }
  },
  mounted() {
    // window.$('.select-custom').selectpicker();
    this.getItems();
  },
  beforeUnmount() {
    // window.$('.landing-page select.select-custom').selectpicker('destroy');
    // window.$('.landing-page select.select-custom option.bs-title-option').remove();
  },
  computed: {
    statusSearch() {
      return this.filter.status
    },
    pageCount() {
      return Math.ceil(this.total / this.filter.perPage)
    },
    pages() {
      if (this.pageAmount < pageSlotsAmount) return [...Array(this.pageAmount).keys()].map(x => x + 1);

      let min = Math.max(this.pageIndex - (pageSlotsAmount - 1) / 2, 1);
      if (this.pageIndex + 1 >= this.pageAmount) {
        min = this.pageAmount - 4;
      }
      let result = [...Array(pageSlotsAmount).keys()].map(x => x + min);
      result[0] = 1;
      result[pageSlotsAmount - 1] = this.pageAmount;

      return result;
    },
    pageAmount() {
      return Math.max(Math.ceil(this.total / this.filter.perPage), 1);
    },
    pageIndex() {
      return (this.page && Number.isInteger(+this.page)) ? +this.page : 1;
    },
    currentLang() {
      const currentLang = localStorage.getItem('$lang');

      if (currentLang && currentLang !== "" && currentLang !== "ua") {
        return currentLang
      }
      return "uk"
    },
    datePickerLocale() {
      const currentLang = localStorage.getItem('$lang');
      console.log(currentLang)
      if (currentLang && currentLang !== "" && currentLang !== "ua") {
        return currentLang
      }
      return "uk"
    }
  },
  methods: {
    withPopper(dropdownList, component, { width }) {
      /**
       * We need to explicitly define the dropdown width since
       * it is usually inherited from the parent with CSS.
       */
      dropdownList.style.width = width

      /**
       * Here we position the dropdownList relative to the $refs.toggle Element.
       *
       * The 'offset' modifier aligns the dropdown so that the $refs.toggle and
       * the dropdownList overlap by 1 pixel.
       *
       * The 'toggleClass' modifier adds a 'drop-up' class to the Vue Select
       * wrapper so that we can set some styles for when the dropdown is placed
       * above.
       */
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: this.placement,
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -1],
            },
          },
          {
            name: 'toggleClass',
            enabled: true,
            phase: 'write',
            fn({ state }) {
              component.$el.classList.toggle(
                'drop-up',
                state.placement === 'top'
              )
            },
          },
        ],
      });

      /**
       * To prevent memory leaks Popper needs to be destroyed.
       * If you return function, it will be called just before dropdown is removed from DOM.
       */
      return () => popper.destroy()
    },
    onChangeStatus(event, item) {
      // console.log(event, item)
      api.put('/api/callback', { id: item.id, status: event.value })
    },
    getItems() {
      let filer = Object.assign({}, this.filter);
      if (this.orderDate && this.orderDate.start && this.orderDate.end) {
        filer = Object.assign(filer, {
          created_at: [
            this.orderDate.start.getTime() / 1000 | 0,
            this.orderDate.end.getTime() / 1000 | 0
          ]
        });
        filer.created_at[0] = filer.created_at[0] - filer.created_at[0] % 86400;
        filer.created_at[1] = (filer.created_at[1] - filer.created_at[1] % 86400) + 86400;
      }
      api.post('/api/callback', { filter: filer, sortBy: this.sortBy }).then(response => response.data).then(
        data => {
          this.items = data.result.map(i => {
            i.created_at = new Date(i.created_at);
            i.updated_at = new Date(i.updated_at);

            return i
          });
          this.filter.page = data.page;
          this.total = data.total;
        })
    }
  },
  watch: {
    page(val) {
      this.filter.page = val;
      this.getItems()
    },
    statusSearch(val) {
      this.getItems()
    },
    orderDate() {
      this.getItems()
    }
  }
}
</script>

<style scoped></style>